import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
export default {
    selectFilter: {
        datapoint: {
            name: 'TnS_SelectFilter',
            customData: function (viewFilter, actionSource) { return [
                viewFilter,
                actionSource,
            ]; },
        },
    },
    selectSort: {
        datapoint: {
            name: 'TnS_MailListSelectSort',
            customData: function (sortColumn, sortDirection, tableView, actionSource) { return [
                sortColumn,
                sortDirection,
                actionSource,
                tableView.totalRowsInView,
                folderIdToName(tableView.tableQuery.folderId),
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map